export const USER_CREDENTIALS_STATUS = {
  PROCESSING: 'processing',
  DONE: 'done',
  CANCELLED: 'cancelled'
};

export const isUserCredentialsProcessing = task =>
  task?.status === USER_CREDENTIALS_STATUS.PROCESSING;

export const isUserCredentialsDone = task =>
  task?.status === USER_CREDENTIALS_STATUS.DONE;

export const isUserCredentialsCancelled = task =>
  task?.status === USER_CREDENTIALS_STATUS.CANCELLED;

export const isUserCredentialsActive = task =>
  Boolean(task) &&
  !isUserCredentialsCancelled(task) &&
  !isUserCredentialsDone(task);

/** QES provider modal embeds credentials — suppress global overlay popup */
export const isUserCredentialsEmbedInCaller = task =>
  Boolean(task?.embedInCaller);

export const createUserCredentialsTask = ({
  status,
  customRecipientsDataSource,
  customTitle,
  embedInCaller
} = {}) => ({
  status,
  ...(customRecipientsDataSource && { customRecipientsDataSource }),
  ...(customTitle && { customTitle }),
  ...(embedInCaller ? { embedInCaller: true } : {})
});
